import React from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  Box,
  Typography,
  useTheme,
  Tooltip,
} from "@mui/material";



export default function HistoryList({
  items,
  collapsed,
  onItemClick,
  activeConvId,
  chatRef, // ✅ add chatRef
}) {
  const theme = useTheme();
  const darkMode = theme.palette.mode === "dark";

  const generateChatTitle = (conv) => {
    if (conv.name) return conv.name;
    return "New Chat";
  };

  if (!items.length) {
    return (
      <Box
        sx={{
          p: 2,
          textAlign: "center",
          color: darkMode ? "#94a3b8" : "#64748b",
          border: `1px dashed ${darkMode ? "#475569" : "#d1d5db"}`,
          borderRadius: 2,
          mt: 2,
          fontSize: "0.85rem",
        }}
      >
        <Typography variant="body2" sx={{ fontStyle: "italic" }}>
          No recent history
        </Typography>
      </Box>
    );
  }

  return (
    <List sx={{ p: 0, mt: 1 }}>
      {items.map((conv) => {
        const isActive = conv.id === activeConvId;
        const fullTitle = generateChatTitle(conv);

        return (
          <Tooltip key={conv.id} title={fullTitle} placement="right" arrow>
            <ListItemButton
              key={conv.id}
              selected={isActive}
              onClick={() => onItemClick?.(conv)}
              sx={{
                py: 1,
                px: 2,
                borderRadius: 1,
                mb: 0.5,
                backgroundColor: isActive
                  ? darkMode
                    ? "rgba(255,255,255,0.12)"
                    : "#e2e8f0"
                  : "transparent",
                "&:hover": {
                  backgroundColor: darkMode
                    ? "rgba(255,255,255,0.08)"
                    : "#f1f5f9",
                },
                cursor: "pointer",
              }}
            >
              <ListItemText
                primaryTypographyProps={{
                  noWrap: true,
                  fontSize: "0.9rem",
                  fontWeight: isActive ? 600 : 500,
                  color: darkMode ? "#e2e8f0" : "#1e293b",
                }}
                secondaryTypographyProps={{
                  noWrap: true,
                  fontSize: "0.75rem",
                  color: darkMode ? "#94a3b8" : "#64748b",
                }}
                primary={fullTitle}
                secondary={
                  conv.timestamp
                    ? new Date(conv.timestamp).toLocaleDateString(undefined, {
                        month: "short",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : ""
                }
              />
            </ListItemButton>
          </Tooltip>
        );
      })}
    </List>
  );
}
